export const focusableElements = (root) => Array.from(root?.querySelectorAll(
    'button, a[href], input, select, textarea, [tabindex]'
) || []).filter((element) => {
    if (element.tabIndex < 0 || element.matches(':disabled') || element.closest('fieldset:disabled, [hidden], [inert]')) return false;
    for (let current = element; current && current !== root?.parentElement; current = current.parentElement) {
        const style = window.getComputedStyle(current);
        if (style.display === 'none' || style.visibility === 'hidden') return false;
    }
    return true;
});
